var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import TaskService, { editFormStateToUpdateTaskTaskArgType, } from "../../../Services/Task.service";
import useUniqueId from "../../Hooks/useUniqueId";
import ViewModal from "../ActivityItem/ViewModal";
import { ViewModalFormFormat } from "../../UI/FormFormat/FormFormat";
import TaskUpdateForm from "./TaskUpdateForm";
import TaskEditForm from "./TaskEditForm";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import ActivityItemTypeService from "../../../Domain/ActivityItemType/ActivityItemType.service";
import useHasPermission from "../../Hooks/useHasPermission";
import PersonService from "../../../Services/Person.service";
import TaskInfo from "./TaskInfo";
const TaskDetailModal = (_a) => {
    var _b;
    var { taskOrTaskId, setTask } = _a, modalProps = __rest(_a, ["taskOrTaskId", "setTask"]);
    const canEditTasks = useHasPermission("CAN_EDIT_TASKS");
    const [meState, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    const makeId = useUniqueId()[1];
    const [taskState, loadTask, taskActions] = useService(React.useCallback(() => {
        if (typeof taskOrTaskId === "number") {
            return TaskService.getTask(taskOrTaskId);
        }
        return Promise.resolve(taskOrTaskId);
    }, [taskOrTaskId]));
    React.useEffect(() => {
        if (modalProps.isOpen) {
            loadTask();
        }
    }, [loadTask, modalProps.isOpen]);
    const taskId = typeof taskOrTaskId === "number" ? taskOrTaskId : taskOrTaskId.id;
    return (_jsx(ViewModal, Object.assign({}, modalProps, { size: "xl", onModalClosed: () => {
            modalProps.onModalClosed();
        }, disableCommenting: ((_b = taskState.data) === null || _b === void 0 ? void 0 : _b.isPrivate)
            ? "Private tasks cannot be commented on"
            : null, activityItemId: taskId, activityItemTypeId: ActivityItemTypeService.TaskId, actions: [
            {
                icon: "fal fa-caret-square-up",
                title: "Update",
                // eslint-disable-next-line react/display-name
                modalBodyAndFooter: (changeStatusProps) => (_jsx(ServiceResult, { state: taskState, children: (task) => (_jsx(ViewModalFormFormat, { onCancel: changeStatusProps.cancelAction, defaultValue: { status: task.status }, handleSubmit: (form) => {
                            var _a;
                            return TaskService.updateTaskStatus(task.id, form.status.id, {
                                notifyPersonIds: (_a = form.peopleToNotify) === null || _a === void 0 ? void 0 : _a.map((person) => person.personId),
                                comment: form.comment,
                            })
                                .then(() => {
                                if (setTask) {
                                    setTask(Object.assign(Object.assign({}, task), { status: form.status }));
                                }
                                taskActions.edit(Object.assign(Object.assign({}, task), { status: form.status }));
                            })
                                .then(changeStatusProps.cancelAction);
                        }, children: (formVals) => (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("breadcrumb"), children: "Task" }), _jsxs("ol", { className: "breadcrumb py-1", id: makeId("breadcrumb"), children: [task.actionPlanTitle && (_jsx("li", { className: "breadcrumb-item", children: _jsx("span", { children: task.actionPlanTitle }) })), _jsx("li", { className: "breadcrumb-item", children: task.title })] })] }), _jsx(TaskUpdateForm, Object.assign({}, formVals, { oldTaskStatusId: task.status.id }))] })) })) })),
            },
            // @ts-expect-error - TS2322 - Type '{ icon: string; title: string; modalBodyAndFooter: (editStatusProps: any) => Element; } | null' is not assignable to type 'undefined'.
            canEditTasks
                ? {
                    icon: "fal fa-pencil-alt",
                    title: "Edit",
                    // eslint-disable-next-line react/display-name
                    modalBodyAndFooter: (editStatusProps) => (_jsx(ServiceResult, { state: taskState, children: (task) => (_jsx(ViewModalFormFormat
                        // @ts-expect-error - TS2352 - Conversion of type 'Task' to type 'TaskEditFormState' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first. | TS2352 - Conversion of type 'Task' to type 'TaskEditFormState' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
                        , { 
                            // @ts-expect-error - TS2352 - Conversion of type 'Task' to type 'TaskEditFormState' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first. | TS2352 - Conversion of type 'Task' to type 'TaskEditFormState' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
                            defaultValue: task, onCancel: editStatusProps.cancelAction, handleSubmit: (form) => {
                                var _a;
                                return TaskService.updateTask(editFormStateToUpdateTaskTaskArgType(task.id, form), {
                                    peopleToNotify: (_a = form.peopleToNotify) === null || _a === void 0 ? void 0 : _a.map((person) => person.personId),
                                    comment: form.comment,
                                })
                                    .then((newTask) => {
                                    if (setTask) {
                                        setTask(newTask);
                                    }
                                    taskActions.edit(newTask);
                                })
                                    // Go back to edit screen.
                                    .then(() => editStatusProps.cancelAction());
                            }, children: (formVals) => (_jsx(ServiceResult, { state: meState, children: (me) => (_jsx(TaskEditForm, Object.assign({}, formVals, { taskIsPrivate: task.isPrivate, taskIsInActionPlan: !!task.actionPlanTitle, currentUser: me }))) })) })) })),
                }
                : null,
        ], children: _jsx(ServiceResult, { state: taskState, children: (task) => _jsx(TaskInfo, { task: task }) }) })));
};
export default TaskDetailModal;
